/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostingigposthint3Inputs */

const en_crosspostingigposthint3 = /** @type {(inputs: Crosspostingigposthint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Single image or a carousel of up to 10 images.`)
};

const de_crosspostingigposthint3 = /** @type {(inputs: Crosspostingigposthint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einzelbild oder Karussell mit bis zu 10 Bildern.`)
};

/**
* | output |
* | --- |
* | "Single image or a carousel of up to 10 images." |
*
* @param {Crosspostingigposthint3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostingigposthint3 = /** @type {((inputs?: Crosspostingigposthint3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostingigposthint3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostingigposthint3(inputs)
	return de_crosspostingigposthint3(inputs)
});
export { crosspostingigposthint3 as "crosspostingIgPostHint" }